import React from 'react';
import { DollarSign, Bitcoin, Gem, LineChart } from 'lucide-react';
import { tradingInstruments } from '../data/mock';

const iconMap = {
  DollarSign,
  Bitcoin,
  Gem,
  LineChart
};

export default function TradingInstruments() {
  return (
    <section id="instruments" className="py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Trade Multiple Markets
          </h2>
          <p className="text-lg text-gray-600">
            Access 247+ trading instruments across global markets with competitive spreads and leverage
          </p>
        </div>

        {/* Instruments Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {tradingInstruments.map((instrument) => {
            const Icon = iconMap[instrument.icon];
            return (
              <div 
                key={instrument.id}
                className="relative group bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 border border-gray-200 hover:border-[#ff444f]/30 hover:shadow-xl transition-all duration-300 overflow-hidden"
              >
                {/* Background Decoration */}
                <div className="absolute top-0 right-0 w-32 h-32 bg-[#ff444f]/5 rounded-full blur-2xl group-hover:bg-[#ff444f]/10 transition-colors"></div>
                
                {/* Icon */}
                <div className="relative mb-6">
                  <div className="w-16 h-16 bg-white rounded-2xl shadow-md flex items-center justify-center group-hover:shadow-lg group-hover:scale-110 transition-all duration-300">
                    <Icon className="w-8 h-8 text-[#ff444f]" />
                  </div>
                </div>

                {/* Content */}
                <h3 className="text-2xl font-bold text-gray-900 mb-3 group-hover:text-[#ff444f] transition-colors">
                  {instrument.name}
                </h3>
                <p className="text-gray-600 mb-4 font-medium">
                  {instrument.description}
                </p>
                <p className="text-sm text-gray-500">
                  {instrument.pairs}
                </p>

                {/* Hover Arrow */}
                <div className="absolute bottom-6 right-6 opacity-0 group-hover:opacity-100 transition-opacity">
                  <svg className="w-6 h-6 text-[#ff444f]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                  </svg>
                </div>
              </div>
            );
          })}
        </div>

        {/* Bottom CTA */}
        <div className="mt-12 text-center">
          <p className="text-gray-600">
            Start trading with leverage up to <span className="font-bold text-[#ff444f]">1:1000</span> on selected instruments
          </p>
        </div>
      </div>
    </section>
  );
}
